import React from 'react';
import Icon from '../../../components/AppIcon';

const RegistrationSummary = ({ 
  currentStep, 
  personalInfo, 
  selectedPlan, 
  selectedGym,
  paymentMethod,
  paymentReference,
  onEditStep 
}) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })?.format(amount);
  };

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-md border border-border sticky top-24">
      <h2 className="text-xl font-heading font-semibold text-foreground mb-6">
        Registration Summary
      </h2>
      <div className="space-y-6">
        {currentStep >= 1 && personalInfo?.firstName && (
          <div className="pb-6 border-b border-border">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-medium text-muted-foreground">Personal Info</h3>
              {currentStep > 1 && (
                <button
                  onClick={() => onEditStep(1)}
                  className="text-xs text-primary hover:underline"
                >
                  Edit
                </button>
              )}
            </div>
            <p className="text-sm font-medium text-foreground">
              {personalInfo?.firstName} {personalInfo?.lastName}
            </p>
            <p className="text-xs text-muted-foreground mt-1">{personalInfo?.email}</p>
            <p className="text-xs text-muted-foreground">{personalInfo?.phone}</p>
            {selectedGym && (
              <div className="mt-3 pt-3 border-t border-border">
                <div className="flex items-start gap-2">
                  <Icon name="MapPin" size={16} color="var(--color-primary)" className="mt-0.5" />
                  <div>
                    <p className="text-xs font-medium text-foreground">{selectedGym?.name}</p>
                    <p className="text-xs text-muted-foreground">{selectedGym?.city}, {selectedGym?.state}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {currentStep >= 2 && selectedPlan && (
          <div className="pb-6 border-b border-border">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-medium text-muted-foreground">Membership Plan</h3>
              {currentStep > 2 && (
                <button
                  onClick={() => onEditStep(2)}
                  className="text-xs text-primary hover:underline"
                >
                  Edit
                </button>
              )}
            </div>
            <p className="text-sm font-medium text-foreground">{selectedPlan?.name}</p>
            <p className="text-xs text-muted-foreground mt-1">{selectedPlan?.description}</p>
            <div className="mt-3 flex items-baseline gap-2">
              <span className="text-2xl font-bold text-primary">
                {formatCurrency(selectedPlan?.price)}
              </span>
              <span className="text-xs text-muted-foreground">/{selectedPlan?.billingCycle}</span>
            </div>
            {selectedPlan?.trialDays > 0 && (
              <div className="mt-2 inline-flex items-center gap-1 px-2 py-1 bg-success/10 rounded-md">
                <Icon name="Gift" size={14} color="var(--color-success)" />
                <span className="text-xs font-medium text-success">
                  {selectedPlan?.trialDays}-day free trial
                </span>
              </div>
            )}
          </div>
        )}
        {currentStep >= 3 && paymentMethod && (
          <div className="pb-6 border-b border-border">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-medium text-muted-foreground">Payment Method</h3>
              {currentStep > 3 && (
                <button
                  onClick={() => onEditStep(3)}
                  className="text-xs text-primary hover:underline"
                >
                  Edit
                </button>
              )}
            </div>
            <p className="text-sm font-medium text-foreground capitalize">
              {paymentMethod === 'pay_at_gym' ? 'Pay at Gym' : paymentMethod}
            </p>
            {paymentMethod === 'pay_at_gym' && paymentReference && (
              <div className="mt-3 bg-muted rounded-lg p-3">
                <p className="text-xs text-muted-foreground mb-1">Reference Number:</p>
                <p className="text-sm font-mono font-bold text-foreground">
                  {paymentReference?.reference_number}
                </p>
                <p className="text-xs text-warning mt-2">Account pending payment</p>
              </div>
            )}
          </div>
        )}
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center gap-2 mb-3">
            <Icon name="Lock" size={16} color="var(--color-success)" />
            <span className="text-xs font-medium text-foreground">Secure Registration</span>
          </div>
          <p className="text-xs text-muted-foreground">
            Your information is encrypted and secure. We never share your personal data.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSummary;